import React from 'react';

const EventTiles = ({ events = [] }) => {
  // Default event data if none provided
  const defaultEvents = [
    {
      id: 1,
      title: "La Soirée du Rire - Spectacle Principal",
      date: "2024-12-15",
      time: "20:00",
      location: "Salle de Spectacle de Granby",
      price: "25$",
      status: "active",
      image: "https://via.placeholder.com/400x300/FF6B6B/FFFFFF?text=La+Soirée+du+Rire",
      description: "Un spectacle de comédie hilarant avec les meilleurs humoristes de la région",
      ticketsSold: 150,
      totalCapacity: 200,
      category: "Comedy"
    },
    {
      id: 2,
      title: "Open Mic - Nuit des Talents",
      date: "2024-12-22",
      time: "19:30",
      location: "Café Culturel Granby",
      price: "15$",
      status: "upcoming",
      image: "https://via.placeholder.com/400x300/4ECDC4/FFFFFF?text=Open+Mic",
      description: "Découvrez les nouveaux talents de la comédie locale",
      ticketsSold: 45,
      totalCapacity: 80,
      category: "Open Mic"
    },
    {
      id: 3,
      title: "Workshop d'Écriture Comique",
      date: "2024-12-28",
      time: "14:00",
      location: "Centre Culturel",
      price: "50$",
      status: "upcoming",
      image: "https://via.placeholder.com/400x300/45B7D1/FFFFFF?text=Workshop",
      description: "Apprenez les techniques d'écriture comique avec des professionnels",
      ticketsSold: 12,
      totalCapacity: 25,
      category: "Workshop"
    }
  ];

  const eventsToShow = events.length > 0 ? events : defaultEvents;

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return '#FF6B6B';
      case 'upcoming': return '#4ECDC4';
      case 'soldout': return '#95A5A6';
      case 'cancelled': return '#E74C3C';
      default: return '#95A5A6';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'active': return 'En cours';
      case 'upcoming': return 'À venir';
      case 'soldout': return 'Complet';
      case 'cancelled': return 'Annulé';
      default: return 'Inconnu';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-CA', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <section className="event-tiles-section">
      <div className="container">
        <h2 className="section-title">ÉVÉNEMENTS À VENIR</h2>
        <div className="event-tiles-grid">
          {eventsToShow.map((event) => (
            <div key={event.id} className="event-tile" data-category={event.category}>
              <div className="event-tile-image">
                <img src={event.image} alt={event.title} />
                <div className="event-status" style={{ backgroundColor: getStatusColor(event.status) }}>
                  {getStatusText(event.status)}
                </div>
                <div className="event-category">{event.category}</div>
              </div>
              
              <div className="event-tile-content">
                <h3 className="event-title">{event.title}</h3>
                <p className="event-description">{event.description}</p>
                
                <div className="event-details">
                  <div className="event-detail">
                    <i className="fas fa-calendar-alt"></i>
                    <span>{formatDate(event.date)}</span>
                  </div>
                  <div className="event-detail">
                    <i className="fas fa-clock"></i>
                    <span>{event.time}</span>
                  </div>
                  <div className="event-detail">
                    <i className="fas fa-map-marker-alt"></i>
                    <span>{event.location}</span>
                  </div>
                  <div className="event-detail">
                    <i className="fas fa-ticket-alt"></i>
                    <span>{event.price}</span>
                  </div>
                </div>
                
                <div className="event-tickets">
                  <div className="ticket-progress">
                    <div className="progress-bar">
                      <div 
                        className="progress-fill" 
                        style={{ 
                          width: `${(event.ticketsSold / event.totalCapacity) * 100}%`,
                          backgroundColor: getStatusColor(event.status)
                        }}
                      ></div>
                    </div>
                    <span className="ticket-count">
                      {event.ticketsSold} / {event.totalCapacity} billets vendus
                    </span>
                  </div>
                </div>
                
                <div className="event-actions">
                  <button className="btn-primary">
                    <i className="fas fa-ticket-alt"></i>
                    Acheter des billets
                  </button>
                  <button className="btn-secondary">
                    <i className="fas fa-share-alt"></i>
                    Partager
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventTiles;
